import Loading from '@Components/Loading/Loading'
import { connect } from 'react-redux'
import CustomModal from '@Components/Modal/CustomModal/CustomModal'
import './my-vault.scss'

interface IInstructionModal {
    open: boolean
    onClose: (action: string) => void
    bodytext?: string
    isloading?: boolean
}
const InstructionModal = (props: IInstructionModal) => {
    const { open, onClose, bodytext, isloading } = props
    return (
        <div>
            <CustomModal
                onClose={(action) => onClose && onClose(action)}
                open={open && open}
                modalTitle="Instructions"
            >
                {isloading && (
                    <Loading
                        isLoading={isloading}
                        className="position-relative"
                    />
                )}
                {bodytext && (
                    <div
                        className="instruction-modal modal-body p-0"
                        dangerouslySetInnerHTML={{ __html: bodytext }}
                    />
                )}
                <div className="modal-footer mt-3">
                    <p className="modal-action main-text text-center m-auto">
                        Print
                    </p>
                </div>
            </CustomModal>
        </div>
    )
}

const mapStateToProps = (store: any) => {
    return {
        bodytext: store?.client?.myVault?.instructionLetter,
        isloading: store?.shared?.loadings?.clientLoading,
    }
}

export default connect(mapStateToProps, null)(InstructionModal)
